<template>
    <v-app-bar
      color="transparent"
      class="px-3 py-2"
      height="60"
      elevation="0"
      dense
    >
      <routerLink to="/">
         <img src="../assets/images/logo-removebg-preview.png" width="120" alt="logo">
      </routerLink>
      <v-spacer/>
      <v-btn text color="indigo" class="mr-2"  @click="openCRM">CRM Dashboard</v-btn>
      <v-menu
        offset-y
        open-on-hover
        bottom
      >
       <template v-slot:activator="{ on, attrs }">
         <v-btn
           v-bind="attrs"
           v-on="on"
           fab
           small
           color="indigo"
           class="white--text text-body-1"
          >
             {{ userInitials}}
          </v-btn>
        </template>
        <v-card width="220">
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                  {{ $store.state.userData.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ $store.state.userData.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item to="/profile">
              <v-list-item-icon>
                <v-icon color="indigo">mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="indigo--text" to="/profile">
                Profile
              </v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon color="error">mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="error--text"  @click="logout()">
                Logout
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
      </v-app-bar>
</template>
<script>
import { mapState } from 'vuex'
import { headersAuth, logOut } from '../links'
export default {
  name: 'App Bar',
  computed: {
    ...mapState(['user']),
    userInitials () {
      const name = this.$store.state.userData?.name?.trim()
      if (!name) return ''

      const parts = name.split(' ')

      // One name → take first letter only
      if (parts.length === 1) {
        return parts[0][0].toUpperCase()
      }

      // First + Last name initials
      return (
        parts[0][0].toUpperCase() +
      parts[1][0].toUpperCase()
      )
    }
  },
  methods: {

    logout () {
      const token = localStorage.getItem('TKtoken')
      const header = { headers: headersAuth(token) }
      const api = logOut()
      const body = ''
      this.$http.post(api, body, header).then(response => {
        console.log(response)
        if (response.ok) {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'success' })
          this.$store.commit('setUser', null)
          localStorage.removeItem('TKtoken')
          this.$store.commit('setUserId', null)
          this.$store.commit('setUserData', null)
          this.$store.commit('setEmail', null)
          this.$router.push('/login')
        } else {
          this.$store.commit('showFeedback', { text: response.body.message, color: 'error', requestedData: body })
        }
      }).catch(err => {
        console.error(err)
        this.$store.commit('showFeedback', { text: err.body.message, color: 'error', requestedData: body })
      })
    },
    openCRM () {
      console.log(process.env.VUE__APP_CRM)
      window.open(process.env.VUE_APP_CRM, '_blank')
    }
  }
}
</script>
